export const CHANNEL_COLORS: Record<string, string> = {
  website: '#3b82f6',
};

export const CHANNEL_BG: Record<string, string> = {
  website: 'bg-blue-500',
};

export const CHANNEL_TEXT: Record<string, string> = {
  website: 'text-blue-600',
};

export const CHANNEL_LABEL: Record<string, string> = {
  website: 'Webbchat',
};

export const QUICK_FILTERS = [
  { label: '7 dagar', days: 7 },
  { label: '30 dagar', days: 30 },
  { label: '90 dagar', days: 90 },
] as const;

export const MONTH_NAMES = [
  'Januari',
  'Februari',
  'Mars',
  'April',
  'Maj',
  'Juni',
  'Juli',
  'Augusti',
  'September',
  'Oktober',
  'November',
  'December',
];

export type DailyTotal = {
  date: string;
  total: number;
  byChannel: Record<string, number>;
};
